import Text from 'components/elements/text';
import { CardSection, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import ScheduleCruiseTable from './cruise-table';
import { ScheduleCardHeader } from '../../style';

interface Props {
  parentIndex?: number;
}

export default function CruiseCard({ parentIndex = 0 }: Props) {
  const { t } = useTranslation();
  return (
    <CardSection>
      <ScheduleCardHeader>
        <Text variant="HeadingXSmall">{t('ticketSales:cruise_detail')}</Text>
        {/* <ScheduleCardHeaderRight>
          <Input
            type="text"
            name={`cruisePurchases.${parentIndex}.bookingCode`}
            label={t('ticketSales:reservation_number')}
            labelPlacement={TextLabelPlacementEnum.Left}
            placeholder={t('ticketSales:reservation_number')}
            hideRequiredStar
            noMargin
          />
        </ScheduleCardHeaderRight> */}
      </ScheduleCardHeader>
      <SeparatorVertical $margin={22}>
        <div style={{ height: 2 }} />
      </SeparatorVertical>
      <ScheduleCruiseTable parentIndex={parentIndex} />
    </CardSection>
  );
}
